import { Box } from '@mui/material';
import { Fragment } from 'react';

import { CostCenter } from '~/data/costCenters';
import { EmployeeCostCenter } from '~/data/employee';

import { EmploymentDataCostCenter } from '../EmploymentDataCostCenter';

import { hasCustomFieldsMarkerForCostCenter } from './data';

type Props = {
  empCostCenters: EmployeeCostCenter[];
  costCenters: CostCenter[];
};

export const EmploymentDataAllCostCenters = ({
  empCostCenters,
  costCenters,
}: Props): JSX.Element => {
  return (
    <Box component="span">
      {empCostCenters.map((costCenter, index) => (
        <Fragment key={index}>
          <EmploymentDataCostCenter
            costCenterId={costCenter.fEmpCostCenter}
            percentage={costCenter.fEmpCostCenterPercent}
            hasCustomFields={hasCustomFieldsMarkerForCostCenter(
              costCenter.fEmpCostCenterCustomData,
            )}
            costCenters={costCenters}
          ></EmploymentDataCostCenter>
        </Fragment>
      ))}
    </Box>
  );
};
